import React, { useEffect, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { DoorOpen, DoorOpenFill } from 'react-bootstrap-icons';
import "react-datepicker/dist/react-datepicker.css";
import { headers, url } from '../../utils/const';
import './ventas.css';
import Tickets from '../tickets/tickets';
import { ToPrinter } from '../../utils/print';

function Venta() {
  const formatMoney = (value) => Number(value || 0).toLocaleString('en-EN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  let dataPrint={};
  const [ventas, setVentas] = useState({
    betted: 0,
    winned: 0,
    paid: 0,
    balance: 0,
    deposito: 0,
    retiro: 0,
    balancePlayer:0,
    point: '',
    tickets: [{
      num: 0,
      betted: 0,
      date: '',
      total:0,
      delete: false,
      winner: {
        jackpot: { value: 0 },
        state: false,
        factor: 1,
        amountWinner: 0,
        amountToPay: 0,
        paid: false,
      }
    }]
  })
  const [formDate, setFormDate] = useState({ init: new Date(), end: new Date() })
  const [claimQr, setClaimQr] = useState('');
  const [claimPreview, setClaimPreview] = useState(null);
  const [claimBusy, setClaimBusy] = useState(false);
  const [cameraOpen, setCameraOpen] = useState(false);
  const videoQrRef = useRef(null);
  const cameraStreamRef = useRef(null);
  useEffect(() => {
    GetVentas();
  }, []);
  useEffect(() => {
    if (!cameraOpen) return undefined;
    let cancelled = false;
    let frameId;
    const startCamera = async () => {
      try {
        if (!window.BarcodeDetector) throw new Error('Este navegador no permite leer QR con cámara; use un lector QR USB o pegue el código.');
        const detector = new window.BarcodeDetector({formats:['qr_code']});
        const stream = await navigator.mediaDevices.getUserMedia({video:{facingMode:{ideal:'environment'}}, audio:false});
        cameraStreamRef.current = stream;
        if (!videoQrRef.current || cancelled) return;
        videoQrRef.current.srcObject = stream;
        await videoQrRef.current.play();
        const scan = async () => {
          if (cancelled || !videoQrRef.current) return;
          try {
            const codes = await detector.detect(videoQrRef.current);
            if (codes[0]?.rawValue) {
              setClaimQr(codes[0].rawValue);
              setClaimPreview(null);
              setCameraOpen(false);
              return;
            }
          } catch (_) {}
          frameId = window.requestAnimationFrame(scan);
        };
        scan();
      } catch (error) {
        alert(error.message || 'No se pudo abrir la cámara');
        setCameraOpen(false);
      }
    };
    startCamera();
    return () => {
      cancelled = true;
      if (frameId) window.cancelAnimationFrame(frameId);
      cameraStreamRef.current?.getTracks().forEach((track)=>track.stop());
      cameraStreamRef.current = null;
    };
  }, [cameraOpen]);
  const ProcessClaimQr = async () => {
    if (!claimQr.trim()) return alert('Escanee o pegue el código QR del jugador');
    try {
      setClaimBusy(true);
      const res = await fetch(`${url}/ticket/qr/pay`, {
        method:'post', headers, body:JSON.stringify({qr:claimQr.trim()})
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data === 'string' ? data : data?.msg || 'No se pudo procesar el QR');
      if (typeof data?.amountToPay === 'number') {
        setClaimPreview(data);
        return;
      }
      alert(typeof data === 'string' ? data : 'Ticket pagado correctamente');
      setClaimQr('');
      setClaimPreview(null);
      GetVentas();
    } catch (error) {
      alert(error.message || 'Error de conexión al validar el QR');
      setClaimPreview(null);
    } finally {
      setClaimBusy(false);
    }
  };
  /**Funcion para buscar las apuesta en el invtervalo  */
  const GetVentas = () => {
    fetch(`${url}/run/venta`, {
      method: "post",
      headers: headers,
      body: JSON.stringify(formDate),
    })
      .then((res) => res.json())
      .then((data) => {
        setVentas(data);
      });
  };
  /**Imprimir Reporte de Venta */
  const ToPrint = () => {
    const balance = ventas;
    balance.type = "cuadre"
    balance.logo ="hipico";
    balance.date = formDate.init.toLocaleDateString('es-ES') === formDate.end.toLocaleDateString('es-ES') ?
                `Fecha: ${formDate.init.toLocaleDateString('es-ES')}  Hora:${formDate.init.getHours()+':'+formDate.init.getMinutes()+':'+formDate.init.getSeconds()}` : `${formDate.init.toLocaleDateString('es-ES')} al ${formDate.end.toLocaleDateString('es-ES')}`
              
        console.log(balance)
    ToPrinter(balance)
  }
  return (
    <div>
      <div className='p-3 m3'>
      </div>
      <header className='noPrint p-3 m-3'>
        <nav>
          <div className="nvegador">
            <Link className='vol venta' to="/bet">VENTA</Link>
            <Link to="/line" className='vol lin'>LINEA</Link>
            <Link className='vol res' to='/line-pale'>LINEA PALE</Link>
            <Link className='vol volvent' to='/venta'>VOLUMEN DE VENTAS</Link>
            <Link className='vol res' to='/player'>JUGADORES</Link>
            <button className="boton_menu bg-danger" onClick={() => localStorage.clear()}><DoorOpenFill /></button>
          </div>
        </nav>
      </header>

      <div className=' card p-3 m-3 col-10 row noPrint'>

        <div className="col-12 card border-primary mb-3">
          <div className="card-header bg-primary text-white rounded"><strong>Cobro con QR del jugador</strong></div>
          <div className="card-body row g-2 align-items-center">
            <div className="col-md-6">
              <input className="form-control form-control-lg" value={claimQr} onChange={(e)=>{setClaimQr(e.target.value); setClaimPreview(null)}} placeholder="Escanee aquí el QR presentado por el jugador" autoComplete="off" />
            </div>
            <div className="col-md-2"><button className="btn btn-outline-primary btn-lg form-control" onClick={()=>setCameraOpen(true)}>Cámara</button></div>
            <div className="col-md-4">
              <button className={`btn ${claimPreview ? 'btn-success' : 'btn-dark'} btn-lg form-control`} disabled={claimBusy} onClick={ProcessClaimQr}>
                {claimBusy ? 'Validando...' : claimPreview ? `Confirmar pago RD$ ${Number(claimPreview.amountToPay).toLocaleString('en-EN')}` : 'Validar QR'}
              </button>
            </div>
            {claimPreview && <div className="col-12 alert alert-warning mb-0"><strong>Verifique el monto y confirme nuevamente.</strong> Esta acción marcará el ticket como pagado.</div>}
          </div>
        </div>
        <Modal show={cameraOpen} onHide={()=>setCameraOpen(false)} centered>
          <Modal.Header closeButton><Modal.Title>Escanear QR del jugador</Modal.Title></Modal.Header>
          <Modal.Body className="bg-dark text-center">
            <video ref={videoQrRef} className="w-100 rounded" muted playsInline />
            <small className="text-white">Centre el código dentro de la imagen.</small>
          </Modal.Body>
        </Modal>

        <div className='col-12 text-center card-header'><h1>Reporte de Venta</h1></div>
        <div className=' col-12'>
          <hr />
          <div className='card-body row col-12 bg'>
            <div className='col-4'>
              <DatePicker className='form-control' selected={formDate.init} onSelect={(date) => setFormDate((value) => {
                return {
                  ...value, init: date
                }
              })} />
            </div>
            <div className='col-4'>
              <DatePicker className='form-control' selected={formDate.end} onSelect={(date) => setFormDate((value) => {
                return {
                  ...value, end: date
                }
              })} />
            </div>
            <div className='col-4 pb-3 mb-3'>
              <input className='btn btn-danger form-control' type="button" value='Buscar'
                onClick={GetVentas}
              />
            </div>
            <div className="col-12 row p-0 m-0">
              {typeof ventas == "object" ? (
                <div className="col-12 row pt-1 mt-1">
                  <div className="col-3 fs-5">
                    Monto Apostado: <strong>RD:$ {formatMoney(ventas?.betted)}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Monto Ganado: <strong>RD:$ {formatMoney(ventas?.winned)}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Monto Pagado: <strong>RD:$ {formatMoney(ventas?.paid)}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Balance: <strong>RD:$ {formatMoney(ventas?.balance)}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Recargas: <strong>RD:$ {formatMoney(ventas?.deposito)}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Retiros: <strong>RD:$ {formatMoney(ventas?.retiro)}</strong>
                  </div>
                  <div className="col-3 fs-5">
                    Balance: <strong>RD:$ {formatMoney(ventas?.balancePlayer)}</strong>
                  </div>
                  <div className="col-3 fs-5 bg-warning">
                    Total en Caja: <strong className="fs-5">RD:$ {formatMoney(ventas?.total)}</strong>
                  </div>
                </div>
              ) : (
                <div>{ventas}</div>
              )}
              <div className="col-12 fs-5 row">
                <div className="col-4 p-3 m-3">
                  <input type="button" value="Print" onClick={async()=>ToPrint()} className="btn btn-primary form-control" />
                </div>
                <div className="col-6">{ventas && ventas.tickets?.length > 1 && <Tickets tickets={ventas.tickets} />}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Venta
